import { useSignal } from '@preact/signals';
import { useLocation } from 'preact-iso';

import { Button, Notice } from '@amumin/ui';

import { api, errorMessage, isApiError } from '../api.js';
import { AuthLayout, tokenFromUrl } from '../components/AuthLayout.js';
import { messages } from '../state/session.js';

/**
 * Landingspagina van de verificatiemail: GET wijzigt niets (link-scanners), de knop doet de POST
 * (ONTWERP.md §13 CSRF-regel). Geen sessie na verificatie; door naar /login.
 */
export function VerifyPage() {
  const { query, route } = useLocation();
  const m = messages.value;
  const token = tokenFromUrl(query);
  const busy = useSignal(false);
  const error = useSignal<string | undefined>(undefined);

  const submit = async () => {
    if (!token) return;
    busy.value = true;
    error.value = undefined;
    try {
      await api.app.auth.verify(token);
      route('/login?verified=1', true);
    } catch (e) {
      error.value =
        isApiError(e, 400) || isApiError(e, 404) ? m.web.verifyInvalid : errorMessage(e, m);
    } finally {
      busy.value = false;
    }
  };

  return (
    <AuthLayout title={m.web.verifyTitle}>
      {!token ? <Notice kind="error">{m.web.tokenMissing}</Notice> : null}
      {error.value ? <Notice kind="error">{error.value}</Notice> : null}
      <p>{m.web.verifyIntro}</p>
      <Button
        name="verify"
        variant="primary"
        block
        busy={busy.value}
        disabled={!token}
        onPress={() => void submit()}
      >
        {busy.value ? m.web.verifying : m.web.verifyButton}
      </Button>
      <p class="auth-links">
        <a href="/login">{m.web.toLogin}</a>
      </p>
    </AuthLayout>
  );
}
